import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import SearchForm from 'app/commons/components/SearchForm';
import { withGlobalData } from 'app/utils/withGlobalData';
import ListJokes from 'app/components/jokes/ListJokes';
import Paginate from 'app/commons/components/Paginate';
import { buildParams } from 'app/utils/pagination';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import * as listenApi from 'app/requests/listens';
import { useState, useEffect } from 'react';
import { setNewParams } from 'app/utils/ga';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

export default function Index({ jokes }) {
  const router = useRouter()
  const { t } = useTranslation();
  const defaultParam = {
    keyword: router.query.keyword || '',
    page: router.query.page || 1
  };
  const [params, setParams] = useState(defaultParam);
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    if (isChange) {
      const url = `/jokes/${buildParams(params)}`;
      router.push(url, url);
    }
    setIsChange(true);
  }, [params]);

  const setDataParams = (value: number | string, name: string, page: number | null = null) => {
    setNewParams(setParams, params, value, name, page);
  }

  const renderListItem = () => {
    return (
      <div className="form-group mt-3">
        {jokes?.data?.length > 0 &&
          <div>
            <ListJokes jokes={jokes.data} code={router?.locale} />
            <Paginate
              data={jokes}
              handleChangePage={(page: number) => setDataParams(page, 'page')}
            />
          </div>
        }
        {!jokes?.data?.length &&
          <div className='text-danger text-center mt-3 text-size-xl'>
            {t('commons.result_notfound')}
          </div>
        }
      </div>
    )
  }

  return (
    <section className="box-card-area list-test">
      <NextSeo
        title={t('routes.joke_des')}
        description={t('routes.joke_des')}
        additionalMetaTags={[{
          name: 'keywords',
          content: `truyện cười tiếng anh, học tiếng anh qua truyện cười, joke english`
        }]}
      />
      <div className="container-md" id="joke">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title={t('routes.joke_des')} />
              <div className='mt-3 col-md-6 p-1 d-block mx-auto'>
                <SearchForm setDataParams={setDataParams} />
              </div>
              {renderListItem()}
            </div>
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  const params = { ...query, direction: 'desc', limit: 30, code: locale };

  try {
    const [jokes, translations] = await Promise.all([
      listenApi.getJokes(params),
      serverSideTranslations(locale, ['common']),
    ]);

    return {
      props: {
        ...translations,
        jokes,
      },
    };
  } catch (error) {
    console.error('Error fetching jokes or translations:', error);
    return { notFound: true };
  }
});

